import React, { useState } from 'react';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { useMediaQuery } from '@mui/material';

import DialogStepThree from 'components/TrackingCode/Dialogs/DialogStepThree';
import { VERIFICATION } from 'constants/verification';
import DialogStepOne from 'containers/main/Dialog/DialogStepOne';
import DialogStepTwo from 'containers/main/Dialog/DialogStepTwo';

const VerificationToken = compose(
  inject('store'),
  observer,
)(({ store, closeDialog, setImages }) => {
  const [showDialogNext, setShowDialogNext] = useState(1);
  const [hasToken, setHasToken] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const handleCloseDialog = () => {
    closeDialog();
    setShowDialogNext(0);
    store.deliveryStore.setCodeVerified();
    store.deliveryStore.setVerificationMethod(VERIFICATION.SMS);
    store.podStore.updateCurrentStep(0);
    store.podStore.updateIsRequested(false);
  };

  const handleNext = (v) => {
    setShowDialogNext(v);
    store.podStore.updateCurrentStep(v);
    if (v >= 3 && isMobile) {
      store.deliveryStore.getPOD((res) => {
        store.podStore.updateCurrentStep(4);
        // Validate that res.data is an array before setting it
        const images = Array.isArray(res.data) ? res.data : [];
        setImages(images);
        store.podStore.setImagesPOD(images);
        store.deliveryStore.getPackageLocation();
        store.deliveryStore.getFeedback();
      });
    }
  };

  const handleClose = () => {
    store.podStore.updateCurrentStep(4);
  };

  return (
    <>
      {showDialogNext === 1 && (
        <DialogStepOne handleClose={handleCloseDialog} handleNext={(v) => handleNext(v)} closeDialog={closeDialog} isDisplayMenu={true} />
      )}
      {showDialogNext === 2 && (
        <DialogStepTwo
          handleClose={handleCloseDialog}
          handleNext={(v) => handleNext(v)}
          setHasToken={(val) => setHasToken(val)}
          closeDialog={closeDialog}
          isDisplayMenu={true}
        />
      )}
      {showDialogNext === 3 && !isMobile && <DialogStepThree handleClose={handleClose} isSuccess={hasToken} setImages={(val) => setImages(val)} />}
    </>
  );
});

export default VerificationToken;
